var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50040)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00146484 20.5H20.0013L17.157 11.2589H2.84286L-0.00146484 20.5ZM1.58536 19.3281L3.7083 12.4308H16.2915L18.4145 19.3281H1.58536Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6942 11.9317L13.9035 20.0009L15.0624 19.8272L13.8532 11.758L12.6942 11.9317Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09635 20.0009L7.30557 11.9317L6.14664 11.758L4.93742 19.8272L6.09635 20.0009Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59525 7.96175C5.59525 9.07785 6.50004 9.98265 7.61615 9.98265C8.73225 9.98265 9.63704 9.07785 9.63704 7.96175C9.63704 6.84564 8.73225 5.94085 7.61615 5.94085C6.50004 5.94085 5.59525 6.84564 5.59525 7.96175ZM7.61615 8.81077C7.14725 8.81077 6.76712 8.43064 6.76712 7.96175C6.76712 7.49285 7.14725 7.11272 7.61615 7.11272C8.08504 7.11272 8.46517 7.49285 8.46517 7.96175C8.46517 8.43064 8.08504 8.81077 7.61615 8.81077Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3628 6.52681C10.3628 7.64291 11.2676 8.54771 12.3837 8.54771C13.4998 8.54771 14.4046 7.64291 14.4046 6.52681C14.4046 5.4107 13.4998 4.50591 12.3837 4.50591C11.2676 4.50591 10.3628 5.4107 10.3628 6.52681ZM12.3837 7.37583C11.9148 7.37583 11.5347 6.9957 11.5347 6.52681C11.5347 6.05791 11.9148 5.67779 12.3837 5.67779C12.8526 5.67779 13.2327 6.05791 13.2327 6.52681C13.2327 6.9957 12.8526 7.37583 12.3837 7.37583Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63706 3.15872L9.63704 7.96175H8.46517L8.46518 2.28763L14.4046 0.5V6.52681H13.2327L13.2327 2.07651L9.63706 3.15872Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26217 3.92141V5.09328H4.43405V3.92141H3.26217Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5481 7.96323V9.13511H16.72V7.96323H15.5481Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37851 1.89947V3.07134H6.55038V1.89947H5.37851Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5859 19.914V11.8448H9.41398V19.914H10.5859Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8699 14.981H2.12995V16.1529H17.8699V14.981Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.8114ad5db48eb63da2b5bbc8048a2957.svg";
export { ForwardRef as ReactComponent };